<template>
  <div>
    <NewFile
      :boxHeight="boxHeight"
      :multiple="true"
      message="Drop files or click to browse to upload to this collection"
      :fileName="false"
      :basePath="basePath"
      @success="success"
      :randomSuffix="true"
    ></NewFile>
  </div>
</template>

<script>
import NewFile from "@/echoComponents/file/NewFile";
export default {
  name: "upload-content",
  props: ["colID", "boxHeight"],
  components: {
    NewFile,
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    basePath() {
      const year = new Date().getFullYear();
      return `files/${year}/collections/${this.colID}`;
    },
  },
  methods: {
    success(payload) {
      payload.what = "collection-file";
      payload.version = 1;
      payload.colID = this.colID;
      payload.status = "signed";
      payload.events = [
        {
          action: "Uploaded",
          user: this.user.name,
          date: new Date(),
        },
      ];
      // Collection uploads are represented as file documents only.
      this.$store.dispatch("files/insert", payload);
    },
  },
};
</script>

<style scoped>
</style>